/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import * as Yup from 'yup';

export const STAFF_HEADING = {
  ALL: 'All',
  LOGISTICS: 'Logistics',
  ACCOUNTS: 'Accounts',
  SALESANDMARKETING: 'Sales and Marketing',
  RESOURCEMANAGER: 'Resource Manager',
  BDE: 'BDE',
  PURCHASE: 'Purchase',
};

export const getStaffInitialValues = (value) => {
  const {
    email,
    id,
    firstName,
    middleName,
    lastName,
    permissions,
    roles,
    phone,
    callingCode,
    assignedTraders,
  } = value;

  const val = {
    email,
    id,
    firstName,
    middleName,
    lastName,
    phone,
    callingCode: { id: callingCode.id, callingCode: callingCode.callingCode },
    roles,
    permissions,
    assignedTraders,
  };
  return val;
};

export const staffValidationSchema = Yup.object({
  email: Yup.string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  firstName: Yup.string('Enter the First Name ')
    .required('First Name is required')
    .trim(),
  lastName: Yup.string('Enter the Last Name ')
    .required('Last Name is required')
    .trim(),
  callingCode: Yup.object().required('Please Select Calling Code'),
  roles: Yup.array()
    .min(1, 'Select atleast one role')
    .required('Please Select Roles'),
  phone: Yup.string()
    .required('Phone number is required')
    .matches(/^\d{8,12}$/, 'Phone number is invalid.')
    .trim(),
});

function IndeterminateCheckbox({ indeterminate, className = '', ...rest }) {
  const ref = React.useRef(null);

  React.useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + ' cursor-pointer'}
      {...rest}
    />
  );
}

export const staffAssociatedVendorColumns = [
  {
    id: 'select',
    header: ({ table }) => (
      <>
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      </>
    ),
    cell: ({ row }) => (
      <div className="px-1">
        <IndeterminateCheckbox
          {...{
            checked: row.getIsSelected(),
            disabled: !row.getCanSelect(),
            indeterminate: row.getIsSomeSelected(),
            onChange: row.getToggleSelectedHandler(),
          }}
        />
      </div>
    ),
  },
  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    sort: false,
    cell: ({ row }) => (
      <div>{`${row?.original?.firstName} ${row?.original?.lastName}`}</div>
    ),
  },
  {
    accessorKey: 'phone',
    header: 'Phone Number',
    sort: false,
    cell: ({ row }) => (
      <div>{`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}</div>
    ),
  },
  {
    accessorKey: 'email',
    header: 'Email',
    sort: false,
  },
  {
    accessorKey: 'rmAssignedAt',
    header: 'Assigned From',
    // cell: ({ row }) => <DateFormatter dateTime={row?.original?.rmAssignedAt} />,
    sort: false,
  },
];

export const allocateVendorColumns = [
  {
    accessorKey: 'firstName',
    header: 'VENDOR',
    sort: false,
    cell: ({ row }) => (
      <div>{`${row?.original?.firstName} ${row?.original?.lastName}`}</div>
    ),
  },
  {
    accessorKey: 'phone',
    header: 'Phone Number',
    sort: false,
    cell: ({ row }) => (
      <div>{`${row?.original?.callingCode?.callingCode}-${row?.original?.phone}`}</div>
    ),
  },
  {
    accessorKey: 'email',
    header: 'Email',
    sort: false,
  },
  {
    accessorKey: 'actions',
    header: '',
    sort: false,
  },
];
